module.exports = __webpack_public_path__ + "img/picnic_inner_4.e718d0ed.jpg";